import { render, staticRenderFns } from "./svg-warning.vue?vue&type=template&id=a10e98ee&"
import script from "./svg-warning.vue?vue&type=script&lang=js&"
export * from "./svg-warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports